import {
  useMutation,
  UseMutationResult,
  useQuery,
  UseQueryResult,
} from '@tanstack/react-query';
import {
  ImpersonateRequestDTO,
  ImpersonateResponseDTO,
  PopulateSupportOrganizationDTO,
  PopulateSupportUserDTO,
} from 'dtos';
import {
  getApiPopulateSupportGetAllOrganizations,
  getApiPopulateSupportGetUsersByOrganization,
  postApiPopulateSupportImpersonate,
} from 'endpoints';

export function usePopulateSupportGetAllOrganizations(): UseQueryResult<
  PopulateSupportOrganizationDTO[], Error> {
  return useQuery<PopulateSupportOrganizationDTO[], Error>({
    queryKey: ['populate-support-all-organizations'],
    queryFn: getApiPopulateSupportGetAllOrganizations,
  });
}

export function usePopulateSupportGetUsersByOrganization(
  organizationId: number,
): UseQueryResult<PopulateSupportUserDTO[], Error> {
  return useQuery<PopulateSupportUserDTO[], Error>({
    queryKey: ['populate-support-users-by-organization', organizationId],
    queryFn: () => getApiPopulateSupportGetUsersByOrganization({ orgId: organizationId }),
    enabled: organizationId > 0,
  });
}

export function usePopulateSupportImpersonateUser():
UseMutationResult<ImpersonateResponseDTO, Error, ImpersonateRequestDTO> {
  return useMutation<ImpersonateResponseDTO, Error, ImpersonateRequestDTO>({
    mutationFn: (data) => postApiPopulateSupportImpersonate(data),
  });
}
